import { render, staticRenderFns } from "./ViewReportPage.vue?vue&type=template&id=c2c4538c&scoped=true"
import script from "./ViewReportPage.vue?vue&type=script&lang=js"
export * from "./ViewReportPage.vue?vue&type=script&lang=js"
import style0 from "./ViewReportPage.vue?vue&type=style&index=0&id=c2c4538c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c4538c",
  null
  
)

export default component.exports